//@flow
import React from 'react';
import PropTypes from 'prop-types';
import {makeStyles} from '@material-ui/core/styles';
import CircularProgress from '@material-ui/core/CircularProgress';

type Props = {|
  visible?: boolean,
|};

const useStyles = makeStyles(theme => ({
  veilWrap: {
    position: 'fixed',
    zIndex: 100,
    backgroundColor: 'rgba(255, 255, 255, 0.7)',
    top: 0,
    bottom: 0,
    left: 0,
    right: 0,
    width: '100%',
    height: '100%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
}));

export default function LoadingVeil(props: Props) {
  const {visible} = props;
  const classes = useStyles();

  return !!visible ? (
    <div className={classes.veilWrap}>
      <CircularProgress size={80} />
    </div>
  ) : null;
}

LoadingVeil.propTypes = {
  visible: PropTypes.bool,
};
